function Files(props) {
  return (
    <svg width="22" height="23" viewBox="0 0 22 23" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        d="M14.4375 19.656H4.8125C4.63016 19.656 4.4553 19.5836 4.32636 19.4546C4.19743 19.3257 4.125 19.1508 4.125 18.9685V6.59351C4.125 6.41117 4.19743 6.2363 4.32636 6.10737C4.4553 5.97844 4.63016 5.90601 4.8125 5.90601H11.6875L15.125 9.34351V18.9685C15.125 19.1508 15.0526 19.3257 14.9236 19.4546C14.7947 19.5836 14.6198 19.656 14.4375 19.656Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M6.875 5.90601V3.84351C6.875 3.66117 6.94743 3.4863 7.07636 3.35737C7.2053 3.22844 7.38016 3.15601 7.5625 3.15601H14.4375L17.875 6.59351V16.2185C17.875 16.4008 17.8026 16.5757 17.6736 16.7046C17.5447 16.8336 17.3698 16.906 17.1875 16.906H15.125"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M7.5625 13.4685H11.6875"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M7.5625 16.2185H11.6875"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export default Files;
